<template>
  <div>
    <el-table :data="records">
      <el-table-column label="coinType" prop="coinType">
      </el-table-column>
      <el-table-column prop="coinAmount" label="可用"> </el-table-column>
      <el-table-column prop="coinFroze" label="冻结"> </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'orderTaskUserAmountRecordList',
  data() {
    return {
      params: {
        coinType: '',
        type: '',
        queryType: '0',
        queryValue: '',
        id: '',
        address: ''
      }
    };
  },
  computed: {
    ...mapState('orderTaskUserAmountRecord', ['records'])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapMutations('orderTaskUserAmountRecord', ['setpage']),
    handleCurrentChange(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', pagination);
    }
  }
};
</script>

<style lang="less" scoped></style>
